import React from 'react';
import PropTypes from 'prop-types';
import {MediaConfiguration, Modal, ThemeContext} from '../../common';
import {NOMEDIASOURCE} from '../../../configs/constants';

function ChangeMediaConfigurationModal(props) {
  const {isModalOpened, onModalClose, defaultAudioSource, defaultVideoSource} = props;

  const onConfirmUserMedia = ({audioSource, videoSource}) => {
    const {onConfirmMedia} = props;

    const videoSourceValue = videoSource === NOMEDIASOURCE ? null : videoSource;
    const audioSourceValue = audioSource === NOMEDIASOURCE ? null : audioSource;

    onConfirmMedia({audioSource: audioSourceValue, videoSource: videoSourceValue});
  };

  return (
    <ThemeContext.Consumer>
      {theme => (
        <Modal
          title="Change Audio/Video Settings"
          isOpen={isModalOpened}
          onClose={onModalClose}
        >
          <MediaConfiguration
            defaultAudioSource={defaultAudioSource}
            defaultVideoSource={defaultVideoSource}
            onConfirmUserMedia={onConfirmUserMedia}
            onClickBack={onModalClose}
            barColor={theme.primaryColor}
          />

        </Modal>
      )}
    </ThemeContext.Consumer>
  );
}

ChangeMediaConfigurationModal.propTypes = {
  isModalOpened: PropTypes.bool.isRequired,
  onModalClose: PropTypes.func.isRequired,
  onConfirmMedia: PropTypes.func.isRequired,
  defaultAudioSource: PropTypes.string.isRequired,
  defaultVideoSource: PropTypes.string.isRequired,
};

export default ChangeMediaConfigurationModal;

